import { render, staticRenderFns } from "./_chat-area-mute.vue?vue&type=template&id=1b79cfea&scoped=true"
import script from "./_chat-area-mute.vue?vue&type=script&lang=js"
export * from "./_chat-area-mute.vue?vue&type=script&lang=js"
import style0 from "./_chat-area-mute.vue?vue&type=style&index=0&id=1b79cfea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b79cfea",
  null
  
)

export default component.exports